import React, { useEffect } from 'react';
import posthog from 'posthog-js';
import { Link, useSearchParams } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './App.css';
import './Cancel.css';

const Cancel: React.FC = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    posthog.capture('checkout_cancelled', { stripe_session_id: sessionId });
    window.scrollTo(0, 0);
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="App">
      <Header showNav={true} />
      <section className="cancel-section">
        <div className="container">
          <div className="cancel-content text-center">
            <div className="cancel-icon">
              <svg
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle
                  cx="40"
                  cy="40"
                  r="40"
                  fill="#EF4444"
                />
                <path
                  d="M30 30L50 50M50 30L30 50"
                  stroke="white"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h1 className="cancel-title">Order Cancelled</h1>
            <p className="cancel-subtitle">
              Your ColorCache purchase was not completed
            </p>

            {sessionId && (
              <div className="session-info">
                <p className="session-id">
                  Session ID:{' '}
                  <span className="session-id-value">{sessionId}</span>
                </p>
              </div>
            )}

            <div className="cancel-message">
              <h2>No worries!</h2>
              <p className="cancel-description">
                You can always come back and complete your purchase later.
                ColorCache will be here when you're ready.
              </p>

              <div className="benefits-reminder">
                <h3>Why ColorCache?</h3>
                <div className="benefits-list">
                  <div className="benefit">
                    <span className="benefit-icon">⚡</span>
                    <span>Save time with one-click color access</span>
                  </div>
                  <div className="benefit">
                    <span className="benefit-icon">🎨</span>
                    <span>Keep your brand colors organized</span>
                  </div>
                  <div className="benefit">
                    <span className="benefit-icon">💾</span>
                    <span>Local storage for reliable access</span>
                  </div>
                  <div className="benefit">
                    <span className="benefit-icon">🔄</span>
                    <span>Works with all Premiere Pro projects</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="cancel-actions">
              <Link
                to="/"
                className="btn btn-primary"
                onClick={scrollToTop}>
                Try Again
              </Link>
              <p className="support-note">
                Questions? Contact us at{' '}
                <a
                  href="mailto:team@codec422.com"
                  className="support-link">
                  team@codec422.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Cancel;
